// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1OA_k","alertIcon":"ConfirmModal_alertIcon__16Fj7"};